import { render, staticRenderFns } from "./TheNavigationDrawerHeader.vue?vue&type=template&id=1e15436a&scoped=true"
import script from "./TheNavigationDrawerHeader.vue?vue&type=script&lang=ts"
export * from "./TheNavigationDrawerHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e15436a",
  null
  
)

export default component.exports